import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BookingProvider } from './components/BookingContext';
import { BookingExperience } from './components/BookingExperience';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { AmbientBackground } from './components/AmbientBackground';
import { HomePage } from './pages/HomePage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { HospitalityPage } from './pages/HospitalityPage';
import { ConveyancingPage } from './pages/ConveyancingPage';
import { FieldServicesPage } from './pages/FieldServicesPage';
import { LogisticsPage } from './pages/LogisticsPage';
import { MaritimePage } from './pages/MaritimePage';
import { RenewablesPage } from './pages/RenewablesPage';
import { IndustryPlaceholder } from './pages/IndustryPlaceholder';
import { SitemapXml } from './pages/SitemapXml';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { HospitalityLaunch } from './pages/HospitalityLaunch';
import { useLocation } from 'react-router-dom';
export function App() {
  const location = useLocation();
  const isHospitalitySubdomain = window.location.hostname.startsWith('hospitality.');
  const isLaunchPage = location.pathname === '/hospitality-launch' || isHospitalitySubdomain && location.pathname === '/';
  return <BookingProvider data-id="element-0">
      <div className="relative min-h-screen bg-brand-black text-white selection:bg-brand-orange/30" data-id="element-1">
        {!isLaunchPage && <AmbientBackground data-id="element-2" />}
        {!isLaunchPage && <Navbar data-id="element-3" />}
        <Routes data-id="element-4">
          <Route path="/" element={isHospitalitySubdomain ? <HospitalityLaunch data-id="element-6" /> : <HomePage data-id="element-7" />} data-id="element-5" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-9" />} data-id="element-8" />
          <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-11" />} data-id="element-10" />
          <Route path="/hospitality-launch" element={<HospitalityLaunch data-id="element-13" />} data-id="element-12" />
          <Route path="/industries/hospitality" element={<HospitalityPage data-id="element-15" />} data-id="element-14" />
          <Route path="/industries/conveyancing" element={<ConveyancingPage data-id="element-17" />} data-id="element-16" />
          <Route path="/industries/field-services" element={<FieldServicesPage data-id="element-19" />} data-id="element-18" />
          <Route path="/industries/logistics" element={<LogisticsPage data-id="element-21" />} data-id="element-20" />
          <Route path="/industries/maritime" element={<MaritimePage data-id="element-23" />} data-id="element-22" />
          <Route path="/industries/renewables" element={<RenewablesPage data-id="element-25" />} data-id="element-24" />
          <Route path="/industries/:slug" element={<IndustryPlaceholder data-id="element-27" />} data-id="element-26" />
        </Routes>
        {!isLaunchPage && <Footer data-id="element-28" />}
        <BookingExperience data-id="element-29" />
      </div>
    </BookingProvider>;
}